import { Card, CardContent, Typography, Chip, Box, IconButton } from "@mui/material"
import CameraAltIcon from "@mui/icons-material/CameraAlt"
import ArchiveIcon from "@mui/icons-material/Archive"
import React from "react"
import AddObservation from "../../../components/Observations/AddObservation"
import LineImage from "./LineImage"

export default function ActiveLine({ line, onArchive }) {
  const [addingObservation, setAddingObservation] = React.useState(false)

  const observations = line?.observations || []
  const observationsWithImages = observations?.filter(
    (ob) => ob.observation_attachments.length > 0
  )
  const firstImages = observationsWithImages?.map((ob) => ({
    s3_key: ob.observation_attachments[0].file.key,
    date: ob.observation_date || ob.date_added,
  }))

  const lineLabel = "Growing Line"
  const lineIcon = "〰️"

  return (
    <>
      <AddObservation
        locationId={line.id}
        observationVersion={2}
        open={addingObservation}
        setOpen={setAddingObservation}
      />
      
      <Card style={{ margin: '10px 0' }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={1}>
            <Typography variant="h6">
              {lineIcon} {line.name || `${lineLabel} ${line.id}`}
            </Typography>
            <Box display="flex" gap={1}>
              <IconButton
                color="primary"
                onClick={() => setAddingObservation(true)}
                title="Add Observation"
                size="small"
                variant="outlined"
              >
                <CameraAltIcon />
              </IconButton>
              <IconButton
                color="error"
                onClick={onArchive}
                title="Archive Line"
                size="small"
                variant="outlined"
              >
                <ArchiveIcon />
              </IconButton>
            </Box>
          </Box>
          <Box display="flex" gap={1} flexWrap="wrap">
            {line.metadata?.species && (
              <Chip label={`Species: ${line.metadata.species}`} size="small" color="secondary" />
            )}
            {line.metadata?.line_type && (
              <Chip label={`Type: ${line.metadata.line_type}`} size="small" />
            )}
            {line.metadata?.deployment_date && (
              <Chip label={`Deployed: ${line.metadata.deployment_date}`} size="small" />
            )}
            {line.metadata?.purpose && (
              <Chip label={`Purpose: ${line.metadata.purpose}`} size="small" color="info" />
            )}
          </Box>
        </CardContent>
      </Card>
      
      {firstImages.length > 0 &&
        firstImages.map((image) => (
          <LineImage
            key={image.s3_key}
            s3_key={image.s3_key}
            observation_date={image.date}
          />
        ))}
    </>
  )
}
